import Vue from 'vue'
import Vuex from 'vuex'
import homeState from './homePage/state'
import carDetailState from './carDetailState/state'
import commonConfigState from './commonConfigState/state'
import financeCalcState from './financeCalcState/state'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		homeState: homeState,
		carDetailState: carDetailState,
		commonConfigState: commonConfigState,
		financeCalcState: financeCalcState
	}
})
